module.exports = __webpack_public_path__ + "img/phoneIcon.5daf3a72.png";